import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createWebsiteInfoAPI,
  deletePrivacyPolicyAPI,
  deleteTermsAndConditionAPI,
  deleteWebsiteOfferingAPI,
  deleteWebsiteOfferingChildAPI,
  deleteWebsiteOfferingChildFileAPI,
  deleteWebsiteSaleOfferAPI,
  deleteWebsiteSaleOfferChildAPI,
  deleteWebsiteSaleOfferChildFileAPI,
  deleteWebsiteFaqAPI,
  deleteWebsiteFilterAPI,
  deleteWebsiteChildAPI,
  getAllWebsiteInfoAPI,
  getAllWebsiteOfferingChildAPI,
  getAllWebsiteSaleOfferAPI,
  getAllWebsiteSaleOfferChildAPI,
  getAllWebsiteFaqAPI,
  getWebsiteFilterAPI,
  getWebsiteFiltersAPI,
  getWebsiteInfoAPI,
  getWebsiteOfferingAPI,
  getWebsiteOfferingChildAPI,
  getWebsiteOfferingChildByIdAPI,
  getWebsiteSaleOfferAPI,
  getWebsiteSaleOfferChildAPI,
  getWebsiteSaleOfferChildByIdAPI,
  getWebsiteFaqAPI,
  getWebsiteTanetInfoAPI,
  makeWebsiteActiveAPI,
  multipWebsiteleFileUploadApi,
  postPrivacyPolicyAPI,
  postTermsAndConditionAPI,
  postWebsiteFilterAPI,
  postWebsiteOfferingAPI,
  postWebsiteOfferingChildAPI,
  postWebsiteSaleOfferAPI,
  postWebsiteSaleOfferChildAPI,
  postWebsiteFaqAPI,
  postWebsiteChildAPI,
  publishWebsiteInfoAPI,
  uploadWebsiteOfferingChildFilesAPI,
  uploadWebsiteSaleOfferChildFilesAPI,
  updatePrivacyPolicyAPI,
  updateTermsAndConditionAPI,
  updateWebsiteFilterAPI,
  updateWebsiteOfferingAPI,
  updateWebsiteOfferingChildAPI,
  updateWebsiteSaleOfferAPI,
  updateWebsiteSaleOfferChildAPI,
  updateWebsiteFaqAPI,
  updateWebsiteChildAPI,
  updateWebsiteInfoAPI,
} from "../../api/common/WebsiteInfoApi";

const initialState = {
  websiteInfoData: null,
  website: [],
  websiteTanent: {},
  loading: false,

  combineFileUploading: false,
  fileuploadResponse: [],

  childLoading: false,
  privacyPolicyLoading: false,
  termsAndConditionLoading: false,
  faqLoading: false,
  privacyPolicyData: null,
  termsAndConditionData: null,
  faqData: null,
  faqList: [],
  websiteFilter: null,
  websiteFilters: [],
  websiteFilterLoading: false,
  websiteOffering: null,
  websiteOfferingLoading: false,
  websiteOfferingChild: null,
  websiteOfferingChildren: [],
  websiteOfferingChildLoading: false,
  websiteOfferingChildFileUploading: false,
  websiteOfferingChildFileResponse: [],
  websiteSaleOffer: null,
  websiteSaleOffers: [],
  websiteSaleOfferLoading: false,
  websiteSaleOfferChild: null,
  websiteSaleOfferChildren: [],
  websiteSaleOfferChildLoading: false,
  websiteSaleOfferChildFileUploading: false,
  websiteSaleOfferChildFileResponse: [],
};

export const multipWebsiteleFileUpload = createAsyncThunk(
  "post/multipleImageUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await multipWebsiteleFileUploadApi(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const updateWebsite = createAsyncThunk(
  "update/website",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteInfoAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteChild = createAsyncThunk(
  "post/childsection",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postPrivacyPolicy = createAsyncThunk(
  "post/privacyPolicy",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postPrivacyPolicyAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updatePrivacyPolicy = createAsyncThunk(
  "put/privacyPolicy",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updatePrivacyPolicyAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deletePrivacyPolicy = createAsyncThunk(
  "delete/privacyPolicy",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await deletePrivacyPolicyAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postTermsAndCondition = createAsyncThunk(
  "post/termsAndCondition",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postTermsAndConditionAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateTermsAndCondition = createAsyncThunk(
  "put/termsAndCondition",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateTermsAndConditionAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteTermsAndCondition = createAsyncThunk(
  "delete/termsAndCondition",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await deleteTermsAndConditionAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteFaq = createAsyncThunk(
  "get/websiteFaq",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteFaqAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllWebsiteFaq = createAsyncThunk(
  "get/allWebsiteFaq",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteFaqAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteFaq = createAsyncThunk(
  "post/websiteFaq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteFaqAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteFaq = createAsyncThunk(
  "put/websiteFaq",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteFaqAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteFaq = createAsyncThunk(
  "delete/websiteFaq",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteFaqAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteFilter = createAsyncThunk(
  "get/websiteFilter",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getWebsiteFilterAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteFilters = createAsyncThunk(
  "get/websiteFilters",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteFiltersAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteFilter = createAsyncThunk(
  "post/websiteFilter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteFilterAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteFilter = createAsyncThunk(
  "put/websiteFilter",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteFilterAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteFilter = createAsyncThunk(
  "delete/websiteFilter",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteFilterAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteChild = createAsyncThunk(
  "put/childsection",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteChild = createAsyncThunk(
  "delete/childsection",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteOffering = createAsyncThunk(
  "get/websiteOffering",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteOfferingAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteOffering = createAsyncThunk(
  "post/websiteOffering",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteOfferingAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteOffering = createAsyncThunk(
  "put/websiteOffering",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteOfferingAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteOffering = createAsyncThunk(
  "delete/websiteOffering",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteOfferingAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteOfferingChild = createAsyncThunk(
  "get/websiteOfferingChild",
  async (websiteOfferingId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteOfferingChildAPI(websiteOfferingId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteOfferingChildById = createAsyncThunk(
  "get/websiteOfferingChildById",
  async (websiteOfferingChildId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteOfferingChildByIdAPI(websiteOfferingChildId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllWebsiteOfferingChild = createAsyncThunk(
  "get/allWebsiteOfferingChild",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteOfferingChildAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteOfferingChild = createAsyncThunk(
  "post/websiteOfferingChild",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteOfferingChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteOfferingChild = createAsyncThunk(
  "put/websiteOfferingChild",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteOfferingChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteOfferingChild = createAsyncThunk(
  "delete/websiteOfferingChild",
  async (websiteOfferingChildId, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteOfferingChildAPI(websiteOfferingChildId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteOfferingChildFile = createAsyncThunk(
  "delete/websiteOfferingChildFile",
  async (uploadId, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteOfferingChildFileAPI(uploadId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const uploadWebsiteOfferingChildFiles = createAsyncThunk(
  "post/uploadWebsiteOfferingChildFiles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadWebsiteOfferingChildFilesAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteSaleOffer = createAsyncThunk(
  "get/websiteSaleOffer",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteSaleOfferAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllWebsiteSaleOffer = createAsyncThunk(
  "get/allWebsiteSaleOffer",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteSaleOfferAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteSaleOffer = createAsyncThunk(
  "post/websiteSaleOffer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteSaleOfferAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteSaleOffer = createAsyncThunk(
  "put/websiteSaleOffer",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteSaleOfferAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteSaleOffer = createAsyncThunk(
  "delete/websiteSaleOffer",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteSaleOfferAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteSaleOfferChild = createAsyncThunk(
  "get/websiteSaleOfferChild",
  async (saleAndOfferId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteSaleOfferChildAPI(saleAndOfferId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteSaleOfferChildById = createAsyncThunk(
  "get/websiteSaleOfferChildById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await getWebsiteSaleOfferChildByIdAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllWebsiteSaleOfferChild = createAsyncThunk(
  "get/allWebsiteSaleOfferChild",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteSaleOfferChildAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const postWebsiteSaleOfferChild = createAsyncThunk(
  "post/websiteSaleOfferChild",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postWebsiteSaleOfferChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateWebsiteSaleOfferChild = createAsyncThunk(
  "put/websiteSaleOfferChild",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteSaleOfferChildAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteSaleOfferChild = createAsyncThunk(
  "delete/websiteSaleOfferChild",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteSaleOfferChildAPI(id);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const deleteWebsiteSaleOfferChildFile = createAsyncThunk(
  "delete/websiteSaleOfferChildFile",
  async (uploadId, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteSaleOfferChildFileAPI(uploadId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const uploadWebsiteSaleOfferChildFiles = createAsyncThunk(
  "post/uploadWebsiteSaleOfferChildFiles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadWebsiteSaleOfferChildFilesAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteInfo = createAsyncThunk(
  "get/websiteInfo",
  async (tenantId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteInfoAPI(tenantId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);
export const makeWebsiteActive = createAsyncThunk(
  "active/websiteInfo",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await makeWebsiteActiveAPI(websiteId);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllWebsiteInfo = createAsyncThunk(
  "get/allWebsiteInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteInfoAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getWebsiteTanetInfo = createAsyncThunk(
  "get/getWebsiteTanetInfo",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getWebsiteTanetInfoAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const createWebsite = createAsyncThunk(
  "create/websiteInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createWebsiteInfoAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const publishWebsite = createAsyncThunk(
  "publish/websiteInfo",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await publishWebsiteInfoAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

const websiteInfoSlice = createSlice({
  name: "website",
  initialState,
  reducers: {
    setWebsiteTanentChild: (state, action) => {
      state.websiteTanent = action.payload;
      state.websiteInfoData = action.payload;
    }
  },
  extraReducers: (builder) => {
    //get user
    builder.addCase(getWebsiteInfo.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getWebsiteInfo.fulfilled, (state, action) => {
      state.websiteInfoData = action.payload.response;
      state.loading = true;
    });
    builder.addCase(getWebsiteInfo.rejected, (state) => {
      state.loading = false;
    });

    //update user
    builder.addCase(updateWebsite.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWebsite.fulfilled, (state, action) => {
      state.websiteInfoData = action.payload.response;
      state.loading = true;
    });
    builder.addCase(updateWebsite.rejected, (state) => {
      state.loading = false;
    });

    //make website active
    builder.addCase(makeWebsiteActive.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(makeWebsiteActive.fulfilled, (state, action) => {
      state.websiteInfoData = action.payload.response;
      state.loading = true;
    });
    builder.addCase(makeWebsiteActive.rejected, (state) => {
      state.loading = false;
    });

    //create user
    builder.addCase(createWebsite.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(createWebsite.fulfilled, (state, action) => {
      state.websiteInfoData = action.payload.response;
      state.loading = true;
    });
    builder.addCase(createWebsite.rejected, (state) => {
      state.loading = false;
    });

    //get user
    builder.addCase(getAllWebsiteInfo.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllWebsiteInfo.fulfilled, (state, action) => {
      state.website = action.payload.response;
      state.loading = true;
    });
    builder.addCase(getAllWebsiteInfo.rejected, (state) => {
      state.loading = false;
    });

    //get user
    builder.addCase(getWebsiteTanetInfo.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getWebsiteTanetInfo.fulfilled, (state, action) => {
      state.websiteTanent = action.payload.response;
      state.loading = true;
    });
    builder.addCase(getWebsiteTanetInfo.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getWebsiteFaq.pending, (state) => {
      state.faqLoading = true;
    });
    builder.addCase(getWebsiteFaq.fulfilled, (state, action) => {
      state.faqData = action.payload.response;
      state.faqLoading = false;
    });
    builder.addCase(getWebsiteFaq.rejected, (state) => {
      state.faqLoading = false;
    });

    builder.addCase(getAllWebsiteFaq.pending, (state) => {
      state.faqLoading = true;
    });
    builder.addCase(getAllWebsiteFaq.fulfilled, (state, action) => {
      state.faqList = action.payload.response || [];
      state.faqLoading = false;
    });
    builder.addCase(getAllWebsiteFaq.rejected, (state) => {
      state.faqLoading = false;
    });

    builder.addCase(publishWebsite.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(publishWebsite.fulfilled, (state, action) => {
      state.websiteInfoData = action.payload.response;
      state.loading = true;
    });
    builder.addCase(publishWebsite.rejected, (state) => {
      state.loading = false;
    });

    //website files
    builder.addCase(multipWebsiteleFileUpload.pending, (state) => {
      state.combineFileUploading = true;
    });
    builder.addCase(multipWebsiteleFileUpload.fulfilled, (state, action) => {
      state.fileuploadResponse = action.payload.response;
      state.combineFileUploading = false;
    });
    builder.addCase(multipWebsiteleFileUpload.rejected, (state) => {
      state.combineFileUploading = false;
    });

    //post website child
    builder.addCase(postWebsiteChild.pending, (state) => {
      state.childLoading = true;
    });
    builder.addCase(postWebsiteChild.fulfilled, (state, action) => {
      state.fileuploadResponse = action.payload.response;
      state.childLoading = false;
    });
    builder.addCase(postWebsiteChild.rejected, (state) => {
      state.childLoading = false;
    });

    builder.addCase(postPrivacyPolicy.pending, (state) => {
      state.privacyPolicyLoading = true;
    });
    builder.addCase(postPrivacyPolicy.fulfilled, (state, action) => {
      state.privacyPolicyData = action.payload.response;
      state.privacyPolicyLoading = false;
    });
    builder.addCase(postPrivacyPolicy.rejected, (state) => {
      state.privacyPolicyLoading = false;
    });

    builder.addCase(updatePrivacyPolicy.pending, (state) => {
      state.privacyPolicyLoading = true;
    });
    builder.addCase(updatePrivacyPolicy.fulfilled, (state, action) => {
      state.privacyPolicyData = action.payload.response;
      state.privacyPolicyLoading = false;
    });
    builder.addCase(updatePrivacyPolicy.rejected, (state) => {
      state.privacyPolicyLoading = false;
    });

    builder.addCase(deletePrivacyPolicy.pending, (state) => {
      state.privacyPolicyLoading = true;
    });
    builder.addCase(deletePrivacyPolicy.fulfilled, (state, action) => {
      state.privacyPolicyData = action.payload.response;
      state.privacyPolicyLoading = false;
    });
    builder.addCase(deletePrivacyPolicy.rejected, (state) => {
      state.privacyPolicyLoading = false;
    });

    builder.addCase(postTermsAndCondition.pending, (state) => {
      state.termsAndConditionLoading = true;
    });
    builder.addCase(postTermsAndCondition.fulfilled, (state, action) => {
      state.termsAndConditionData = action.payload.response;
      state.termsAndConditionLoading = false;
    });
    builder.addCase(postTermsAndCondition.rejected, (state) => {
      state.termsAndConditionLoading = false;
    });

    builder.addCase(updateTermsAndCondition.pending, (state) => {
      state.termsAndConditionLoading = true;
    });
    builder.addCase(updateTermsAndCondition.fulfilled, (state, action) => {
      state.termsAndConditionData = action.payload.response;
      state.termsAndConditionLoading = false;
    });
    builder.addCase(updateTermsAndCondition.rejected, (state) => {
      state.termsAndConditionLoading = false;
    });

    builder.addCase(deleteTermsAndCondition.pending, (state) => {
      state.termsAndConditionLoading = true;
    });
    builder.addCase(deleteTermsAndCondition.fulfilled, (state, action) => {
      state.termsAndConditionData = action.payload.response;
      state.termsAndConditionLoading = false;
    });
    builder.addCase(deleteTermsAndCondition.rejected, (state) => {
      state.termsAndConditionLoading = false;
    });

    builder.addCase(postWebsiteFaq.pending, (state) => {
      state.faqLoading = true;
    });
    builder.addCase(postWebsiteFaq.fulfilled, (state, action) => {
      state.faqData = action.payload.response;
      state.faqLoading = false;
    });
    builder.addCase(postWebsiteFaq.rejected, (state) => {
      state.faqLoading = false;
    });

    builder.addCase(updateWebsiteFaq.pending, (state) => {
      state.faqLoading = true;
    });
    builder.addCase(updateWebsiteFaq.fulfilled, (state, action) => {
      state.faqData = action.payload.response;
      state.faqLoading = false;
    });
    builder.addCase(updateWebsiteFaq.rejected, (state) => {
      state.faqLoading = false;
    });

    builder.addCase(deleteWebsiteFaq.pending, (state) => {
      state.faqLoading = true;
    });
    builder.addCase(deleteWebsiteFaq.fulfilled, (state, action) => {
      state.faqData = action.payload.response;
      state.faqLoading = false;
    });
    builder.addCase(deleteWebsiteFaq.rejected, (state) => {
      state.faqLoading = false;
    });

    builder.addCase(getWebsiteFilter.pending, (state) => {
      state.websiteFilterLoading = true;
    });
    builder.addCase(getWebsiteFilter.fulfilled, (state, action) => {
      state.websiteFilter = action.payload.response;
      state.websiteFilterLoading = false;
    });
    builder.addCase(getWebsiteFilter.rejected, (state) => {
      state.websiteFilterLoading = false;
    });

    builder.addCase(getWebsiteFilters.pending, (state) => {
      state.websiteFilterLoading = true;
    });
    builder.addCase(getWebsiteFilters.fulfilled, (state, action) => {
      state.websiteFilters = action.payload.response || [];
      state.websiteFilterLoading = false;
    });
    builder.addCase(getWebsiteFilters.rejected, (state) => {
      state.websiteFilterLoading = false;
    });

    builder.addCase(postWebsiteFilter.pending, (state) => {
      state.websiteFilterLoading = true;
    });
    builder.addCase(postWebsiteFilter.fulfilled, (state, action) => {
      state.websiteFilter = action.payload.response;
      state.websiteFilterLoading = false;
    });
    builder.addCase(postWebsiteFilter.rejected, (state) => {
      state.websiteFilterLoading = false;
    });

    builder.addCase(updateWebsiteFilter.pending, (state) => {
      state.websiteFilterLoading = true;
    });
    builder.addCase(updateWebsiteFilter.fulfilled, (state, action) => {
      state.websiteFilter = action.payload.response;
      state.websiteFilterLoading = false;
    });
    builder.addCase(updateWebsiteFilter.rejected, (state) => {
      state.websiteFilterLoading = false;
    });

    builder.addCase(deleteWebsiteFilter.pending, (state) => {
      state.websiteFilterLoading = true;
    });
    builder.addCase(deleteWebsiteFilter.fulfilled, (state, action) => {
      state.websiteFilter = action.payload.response;
      state.websiteFilterLoading = false;
    });
    builder.addCase(deleteWebsiteFilter.rejected, (state) => {
      state.websiteFilterLoading = false;
    });

    //update website child
    builder.addCase(updateWebsiteChild.pending, (state) => {
      state.childLoading = true;
    });
    builder.addCase(updateWebsiteChild.fulfilled, (state, action) => {
      state.fileuploadResponse = action.payload.response;
      state.childLoading = false;
    });
    builder.addCase(updateWebsiteChild.rejected, (state) => {
      state.childLoading = false;
    });

     //delete website child
    builder.addCase(deleteWebsiteChild.pending, (state) => {
      state.childLoading = true;
    });
    builder.addCase(deleteWebsiteChild.fulfilled, (state, action) => {
      state.fileuploadResponse = action.payload.response;
      state.childLoading = false;
    });
    builder.addCase(deleteWebsiteChild.rejected, (state) => {
      state.childLoading = false;
    });

    builder.addCase(getWebsiteOffering.pending, (state) => {
      state.websiteOfferingLoading = true;
    });
    builder.addCase(getWebsiteOffering.fulfilled, (state, action) => {
      state.websiteOffering = action.payload.response;
      state.websiteOfferingLoading = false;
    });
    builder.addCase(getWebsiteOffering.rejected, (state) => {
      state.websiteOfferingLoading = false;
    });

    builder.addCase(postWebsiteOffering.pending, (state) => {
      state.websiteOfferingLoading = true;
    });
    builder.addCase(postWebsiteOffering.fulfilled, (state, action) => {
      state.websiteOffering = action.payload.response;
      state.websiteOfferingLoading = false;
    });
    builder.addCase(postWebsiteOffering.rejected, (state) => {
      state.websiteOfferingLoading = false;
    });

    builder.addCase(updateWebsiteOffering.pending, (state) => {
      state.websiteOfferingLoading = true;
    });
    builder.addCase(updateWebsiteOffering.fulfilled, (state, action) => {
      state.websiteOffering = action.payload.response;
      state.websiteOfferingLoading = false;
    });
    builder.addCase(updateWebsiteOffering.rejected, (state) => {
      state.websiteOfferingLoading = false;
    });

    builder.addCase(deleteWebsiteOffering.pending, (state) => {
      state.websiteOfferingLoading = true;
    });
    builder.addCase(deleteWebsiteOffering.fulfilled, (state, action) => {
      state.websiteOffering = action.payload.response;
      state.websiteOfferingLoading = false;
    });
    builder.addCase(deleteWebsiteOffering.rejected, (state) => {
      state.websiteOfferingLoading = false;
    });

    builder.addCase(getWebsiteOfferingChild.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(getWebsiteOfferingChild.fulfilled, (state, action) => {
      state.websiteOfferingChildren = action.payload.response || [];
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(getWebsiteOfferingChild.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(getWebsiteOfferingChildById.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(getWebsiteOfferingChildById.fulfilled, (state, action) => {
      state.websiteOfferingChild = action.payload.response;
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(getWebsiteOfferingChildById.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(getAllWebsiteOfferingChild.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(getAllWebsiteOfferingChild.fulfilled, (state, action) => {
      state.websiteOfferingChildren = action.payload.response || [];
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(getAllWebsiteOfferingChild.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(postWebsiteOfferingChild.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(postWebsiteOfferingChild.fulfilled, (state, action) => {
      state.websiteOfferingChild = action.payload.response;
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(postWebsiteOfferingChild.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(updateWebsiteOfferingChild.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(updateWebsiteOfferingChild.fulfilled, (state, action) => {
      state.websiteOfferingChild = action.payload.response;
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(updateWebsiteOfferingChild.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(deleteWebsiteOfferingChild.pending, (state) => {
      state.websiteOfferingChildLoading = true;
    });
    builder.addCase(deleteWebsiteOfferingChild.fulfilled, (state) => {
      state.websiteOfferingChildLoading = false;
    });
    builder.addCase(deleteWebsiteOfferingChild.rejected, (state) => {
      state.websiteOfferingChildLoading = false;
    });

    builder.addCase(uploadWebsiteOfferingChildFiles.pending, (state) => {
      state.websiteOfferingChildFileUploading = true;
    });
    builder.addCase(uploadWebsiteOfferingChildFiles.fulfilled, (state, action) => {
      state.websiteOfferingChildFileResponse = action.payload.response || [];
      state.websiteOfferingChildFileUploading = false;
    });
    builder.addCase(uploadWebsiteOfferingChildFiles.rejected, (state) => {
      state.websiteOfferingChildFileUploading = false;
    });

    builder.addCase(deleteWebsiteOfferingChildFile.pending, (state) => {
      state.websiteOfferingChildFileUploading = true;
    });
    builder.addCase(deleteWebsiteOfferingChildFile.fulfilled, (state) => {
      state.websiteOfferingChildFileUploading = false;
    });
    builder.addCase(deleteWebsiteOfferingChildFile.rejected, (state) => {
      state.websiteOfferingChildFileUploading = false;
    });

    builder.addCase(getWebsiteSaleOffer.pending, (state) => {
      state.websiteSaleOfferLoading = true;
    });
    builder.addCase(getWebsiteSaleOffer.fulfilled, (state, action) => {
      state.websiteSaleOffer = action.payload.response;
      state.websiteSaleOfferLoading = false;
    });
    builder.addCase(getWebsiteSaleOffer.rejected, (state) => {
      state.websiteSaleOfferLoading = false;
    });

    builder.addCase(getAllWebsiteSaleOffer.pending, (state) => {
      state.websiteSaleOfferLoading = true;
    });
    builder.addCase(getAllWebsiteSaleOffer.fulfilled, (state, action) => {
      state.websiteSaleOffers = action.payload.response || [];
      state.websiteSaleOfferLoading = false;
    });
    builder.addCase(getAllWebsiteSaleOffer.rejected, (state) => {
      state.websiteSaleOfferLoading = false;
    });

    builder.addCase(postWebsiteSaleOffer.pending, (state) => {
      state.websiteSaleOfferLoading = true;
    });
    builder.addCase(postWebsiteSaleOffer.fulfilled, (state, action) => {
      state.websiteSaleOffer = action.payload.response;
      state.websiteSaleOfferLoading = false;
    });
    builder.addCase(postWebsiteSaleOffer.rejected, (state) => {
      state.websiteSaleOfferLoading = false;
    });

    builder.addCase(updateWebsiteSaleOffer.pending, (state) => {
      state.websiteSaleOfferLoading = true;
    });
    builder.addCase(updateWebsiteSaleOffer.fulfilled, (state, action) => {
      state.websiteSaleOffer = action.payload.response;
      state.websiteSaleOfferLoading = false;
    });
    builder.addCase(updateWebsiteSaleOffer.rejected, (state) => {
      state.websiteSaleOfferLoading = false;
    });

    builder.addCase(deleteWebsiteSaleOffer.pending, (state) => {
      state.websiteSaleOfferLoading = true;
    });
    builder.addCase(deleteWebsiteSaleOffer.fulfilled, (state, action) => {
      state.websiteSaleOffer = action.payload.response;
      state.websiteSaleOfferLoading = false;
    });
    builder.addCase(deleteWebsiteSaleOffer.rejected, (state) => {
      state.websiteSaleOfferLoading = false;
    });

    builder.addCase(getWebsiteSaleOfferChild.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(getWebsiteSaleOfferChild.fulfilled, (state, action) => {
      state.websiteSaleOfferChildren = action.payload.response || [];
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(getWebsiteSaleOfferChild.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(getWebsiteSaleOfferChildById.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(getWebsiteSaleOfferChildById.fulfilled, (state, action) => {
      state.websiteSaleOfferChild = action.payload.response;
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(getWebsiteSaleOfferChildById.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(getAllWebsiteSaleOfferChild.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(getAllWebsiteSaleOfferChild.fulfilled, (state, action) => {
      state.websiteSaleOfferChildren = action.payload.response || [];
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(getAllWebsiteSaleOfferChild.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(postWebsiteSaleOfferChild.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(postWebsiteSaleOfferChild.fulfilled, (state, action) => {
      state.websiteSaleOfferChild = action.payload.response;
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(postWebsiteSaleOfferChild.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(updateWebsiteSaleOfferChild.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(updateWebsiteSaleOfferChild.fulfilled, (state, action) => {
      state.websiteSaleOfferChild = action.payload.response;
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(updateWebsiteSaleOfferChild.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(deleteWebsiteSaleOfferChild.pending, (state) => {
      state.websiteSaleOfferChildLoading = true;
    });
    builder.addCase(deleteWebsiteSaleOfferChild.fulfilled, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });
    builder.addCase(deleteWebsiteSaleOfferChild.rejected, (state) => {
      state.websiteSaleOfferChildLoading = false;
    });

    builder.addCase(uploadWebsiteSaleOfferChildFiles.pending, (state) => {
      state.websiteSaleOfferChildFileUploading = true;
    });
    builder.addCase(uploadWebsiteSaleOfferChildFiles.fulfilled, (state, action) => {
      state.websiteSaleOfferChildFileResponse = action.payload.response || [];
      state.websiteSaleOfferChildFileUploading = false;
    });
    builder.addCase(uploadWebsiteSaleOfferChildFiles.rejected, (state) => {
      state.websiteSaleOfferChildFileUploading = false;
    });

    builder.addCase(deleteWebsiteSaleOfferChildFile.pending, (state) => {
      state.websiteSaleOfferChildFileUploading = true;
    });
    builder.addCase(deleteWebsiteSaleOfferChildFile.fulfilled, (state) => {
      state.websiteSaleOfferChildFileUploading = false;
    });
    builder.addCase(deleteWebsiteSaleOfferChildFile.rejected, (state) => {
      state.websiteSaleOfferChildFileUploading = false;
    });
  },
});

export const { setWebsiteTanentChild } = websiteInfoSlice.actions;
export default websiteInfoSlice.reducer;
